module.exports = __webpack_public_path__ + "img/youtube.33883f8a.svg";